import { OptiesIncl } from '../../../api';
import { FormulierProcessDependencies } from '../dependencies';

type Values = {
  resultaatPreAdvies: {
    vraag2: string;
  };
}
export const resultaatPreAdviesFormulierVraag = async (values: Values, deps: FormulierProcessDependencies) => {
  deps.dispatch(s => ({
    ...s,

  }));

  if (values.resultaatPreAdvies.vraag2 === 'Ja,<35%') {
    values.resultaatPreAdvies.vraag2 = OptiesIncl.SmallerThan35;
  }
  if (values.resultaatPreAdvies.vraag2 === 'Ja,35-80%') {
    values.resultaatPreAdvies.vraag2 = OptiesIncl.Between35And80;
  }
  if (values.resultaatPreAdvies.vraag2 === 'Ja,>80%') {
    values.resultaatPreAdvies.vraag2 = OptiesIncl.GreaterThan80;
  }
  if (values.resultaatPreAdvies.vraag2 === 'Niet van toepassing') {
    values.resultaatPreAdvies.vraag2 = OptiesIncl.NietVanToepassing;
  }

};
